import React from 'react';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { getEmbedMediaURL } from '../../../helpers';


import './style.scss';

const VideoPlayer = ({ entity }) => {
  const url = entity.getIn(['field_video', 0, 'embed']);
  const title = entity.getIn(['field_video', 0, 'title']);
  const videoLink = getEmbedMediaURL(url);

  if (!url || !videoLink) {
    return null;
  }

  return (
    <Container>
      <div className="row">
        <div className="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
          <div className="ParagraphVideo">
            <div className="ParagraphVideo__inner">
              <iframe
                title={title}
                width="1280"
                height="720"
                src={videoLink}
                allowFullScreen=""
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default VideoPlayer;
